import * as React from 'react';
import { icons } from '../../style/icons';
import BasicContentSection from '../basic-content-section/BasicContentSection';
import {
  ExperienceWrapper,
  ExperienceImage,
  Margin,
  ExperienceOverflow,
} from './Experience.style';

const Experience = ({ section }) => {
  return (
    <>
      <ExperienceOverflow>
        <ExperienceWrapper>
          <Margin>
            <ExperienceImage
              src={icons.EXPERIENCE.image}
              alt={icons.EXPERIENCE.altText}
            ></ExperienceImage>
          </Margin>
          <BasicContentSection section={section} />
        </ExperienceWrapper>
      </ExperienceOverflow>
    </>
  );
};

export default Experience;
